
<script>
import appConfig from "@/app.config";
import Layout from "../../layouts/main";
///import DeviceOs from "./deviceOs.vue";
import AgeRangeRate from "./ageRangeRate.vue";
import GenderRate from "./genderRate.vue";
import CustomDropDownRate from "./customDropDownRate.vue";
import ReportingApi from "@/services/reporting-api";
//import BrowserType from "./browserType.vue";
import { mapGetters } from 'vuex';
import { frLocale, frRanges } from "@/datePickerConfig.js";

/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports Clients",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, /*DeviceOs, */GenderRate, AgeRangeRate, CustomDropDownRate, /*BrowserType*/ },

  mounted(){
    this.initReportingCustomerCompnent()
  },

  computed:{
     ...mapGetters('menu', ['menuCampaignId', "menuCampaign"]),


  },
  data() {
    const now = new Date();
    const currentYear = now.getFullYear();

    return {
      pagemodelMain: { currentPage: 1, perPage: 15, totalRows: 0 },

      range: {
            startDate: new Date(`${currentYear}-01-01`),
            endDate: now,
          },

      frLocale,
      frRanges,

      showError: false,
      showConfigureQRCode: false,

      // ✅ ONLY useful data now
      userAgentAnalysis: null,
      ageRangeRate: null,
      genderRate: null,
      customDropDownRate: null,

      topClientsData: []
    };
  },

  watch:{

    menuCampaignId:function(){
      this.showConfigureQRCode = false
      this.initReportingCustomerCompnent()

    },

    range:function(){
      this.initReportingCustomerCompnent()
    }

    },

  methods: {
    
    initReportingCustomerCompnent(){
      this.getCampaignReport()
      this.getDashboardByCustomerStats()
    },

    configureQRCode() {
      this.showConfigureQRCode = !this.showConfigureQRCode ;
    },

    clearCampaignReport() {
      this.userAgentAnalysis = null;
      this.ageRangeRate = null;
      this.genderRate = null;
      this.customDropDownRate = null;
    },

    //API CALL//

    getDashboardByCustomerStats() {
      const params = {
        campaignId: this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      ReportingApi.getDashboardByCustomerStats(params).then((res) => {
        if (res) {
          this.topClientsData = res;
        }
      });
    },

    getCampaignReport() {
      if (!this.range?.startDate || !this.range?.endDate || !this.menuCampaignId) {
        return;
      }

      this.clearCampaignReport();

      this.getGenderRate();
      this.getUserAgentAnalysis();
      this.getCustomDropDownRate();
      this.getAgeRangeRate();
    },

    getGenderRate() {
      const params = {
        campaignId: this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      ReportingApi.getGenderRate(params)
        .then(res => {
          this.genderRate = res || null;
        })
        .catch(() => {
          this.genderRate = null;
        });
    },

    getUserAgentAnalysis() {
    const params = {
      campaignId: this.menuCampaignId,
      start: this.range.startDate,
      end: this.range.endDate
    };

    ReportingApi.getUserAgentAnalysis(params)
        .then(res => {
          this.userAgentAnalysis = res || null;
        })
        .catch(() => {
          this.userAgentAnalysis = null;
        });
    },

  getCustomDropDownRate() {
    const params = {
      campaignId: this.menuCampaignId,
      start: this.range.startDate,
      end: this.range.endDate
    };

    ReportingApi.getCustomDropDownRate(params)
      .then(res => {
        this.customDropDownRate = res || null;
      })
      .catch(() => {
        this.customDropDownRate = null;
      });
  },
  getAgeRangeRate() {
    const params = {
      campaignId: this.menuCampaignId,
      start: this.range.startDate,
      end: this.range.endDate
    };

    ReportingApi.getAgeRangeRate(params)
      .then(res => {
        this.ageRangeRate = res || null;
      })
      .catch(() => {
        this.ageRangeRate = null;
      });
  }
  
  }
};
</script>
  
<template>
  <Layout>
    <div class="home-page-80-width"> 

        <div class="my-4 mx-1">
          <div class="row">
            
            <div class="col-lg-9 col-md-7 col-12 mb-2 mb-md-0">
              <h4 class="global-metric-title">Analyse Clients</h4>
              <!-- <div style="font-size: 11px;" v-if="campaignReport && campaignReport.campaignName">
                Client: <a href="#" class="text-primary">{{ menuCampaign.customerName }}</a> | <a href="#" class="text-primary">{{ menuCampaign.menuName }}</a>
              </div> -->
            </div>

            <div class="col-lg-3 col-md-5 col-12 text-right">
              <v-dateRangePicker
                ref="picker"
                v-model="range"
                :autoApply="true"
                :locale-data="frLocale"
                opens="left"
                :ranges="frRanges"
              />
          </div>

          </div>

        </div>

        <div class="mt-4">

          <b-card class="text-left global-metric-card p-3 mx-1 h-100">
            <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
              Top 10 Clients
            </div>

            <div class="table-responsive">
              <table class="table table-borderless mb-0">
                <thead>
                  <tr>
                    <th scope="col">Rang</th>
                    <th scope="col" class="text-center">Client</th>
                    <th scope="col" class="text-center">Téléphone</th>
                    <th scope="col" class="text-center">Commande(s)</th>
                    <th scope="col" class="text-center">Dernière Commande</th>
                    <th scope="col" class="text-right">Dépense Totale</th>
                  </tr>
                </thead>
                <tbody v-if="topClientsData && topClientsData.length">
                  <tr v-for="(client, index) in topClientsData" :key="index">
                    <th scope="row">#{{ index + 1 }}</th>
                    <td class="text-center">{{ client.name }}</td>
                    <td class="text-center">{{ client.phone }}</td>
                    <td class="text-center">{{ client.orderCount }}</td>
                    <td class="text-center">{{ client.lastSubmissionDate }}</td>
                    <td class="font-weight-bold text-right">
                      {{ client.totalTurnover }}
                    </td>
                  </tr>
                </tbody>

              <tbody v-else>
                <tr>
                  <td colspan="5" class="empty-state">
                    <div class="empty-content">
                      <i class="fas fa-user-slash"></i>
                      <p>Aucun client trouvé pour cette période</p>
                    </div>
                  </td>
                </tr>
              </tbody>

              </table>
            </div>
          </b-card>

        </div>

        <div>
<!-- 
          <div class="row mt-md-4 p-md-0" v-if="userAgentAnalysis &&  ((userAgentAnalysis.browserFrequency && Object.keys(userAgentAnalysis.browserFrequency).length > 0) || (userAgentAnalysis.osFrequency && Object.keys(userAgentAnalysis.osFrequency).length > 0))  ">

            <div v-if="userAgentAnalysis && userAgentAnalysis.browserFrequency && Object.keys(userAgentAnalysis.browserFrequency).length > 0 " class="col-12 col-lg-6 pr-lg-2">
              <b-card class="text-left global-metric-card p-3 mx-1 h-100">

                <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
                    Analyse clients / Agent
                </div>

                <BrowserType :browserFrequency="userAgentAnalysis.browserFrequency == null ? null : userAgentAnalysis.browserFrequency" />
              </b-card>
            </div>

            
            <div class="col-md-6 col-12">
              <div class="ml-md-2 ml-0">

                  <b-card class="text-left global-metric-card p-3 mx-1 h-100">

                    <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
                      Système d'exploitation
                    </div>

                    <DeviceOs :osFrequency="userAgentAnalysis.osFrequency == null ? null :userAgentAnalysis.osFrequency" />
                  </b-card>

                  
              </div>

            </div>



            <div class="col-2"/>
          </div> -->

          <!-- 1x Pie charts -->
          <div class="row mt-md-3 mt-4 p-md-0">
            
            <div  v-if="ageRangeRate &&   ageRangeRate.values.length && ageRangeRate.labels.length " class="col-md-6 col-12 pr-lg-2" >
              <b-card class="text-left global-metric-card p-3 mx-1 h-100">

                <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
                  {{$t('campaign.card.ageRangeRate') }}
                </div>

                <AgeRangeRate :ageRangeRate="ageRangeRate" ></AgeRangeRate>
              </b-card>
            </div>

            <div  v-if="genderRate &&   genderRate.count.length && genderRate.labels.length " class="col-md-6 col-12 pl-lg-2 mt-4 mt-md-0" >
              <b-card class="text-left global-metric-card p-3 mx-1 h-100">

                <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
                  {{$t('campaign.card.gender') }}
                </div>

                <GenderRate :genderRate="genderRate" ></GenderRate>
              </b-card>
            </div>

            <div  v-if="customDropDownRate  " class="col-md-6 col-12 pr-lg-2 mt-4" >
              <b-card class="text-left global-metric-card p-3 mx-1 h-100">

                <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
                  {{$t('campaign.card.customDropDownRate') }}
                </div>

                <CustomDropDownRate :customDropDownRate="customDropDownRate" ></CustomDropDownRate>
              </b-card>
            </div>
          

          </div>


          <div v-if=" this.showError" class="text-center text-danger"> {{ $t('campaign.error.notFound') }}</div>




        </div>

    </div>
  </Layout>

</template>


<style scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.gallery-images {
  flex: 1 1 calc(15% - 10px);
  box-sizing: border-box;
  position: relative;
}

.media-container {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 250px;
}
.media-images {
  max-width: 250px;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: filter 0.3s ease;
  position: relative;
  z-index: 1;
}


@media (max-width: 768px) {
  .gallery-images {
    flex: 1 1 calc(50% - 10px);
  }
}

@media (max-width: 480px) {
  .gallery-images {
    flex: 1 1 100%;
  }
}

</style>



<style>

.period-card{
  background-color: #fff;
  color: #000;
  border-radius: 8px;
  padding: 9px 11px;
  color: #334155;
  font-weight: 500;
  border: 1px solid #ddd;
}

.global-metric-title{
  font-weight: bold;
  font-size: 30px;
  color: #000;
}

.global-metric-card{
  border-radius: 16px;
  border: 1px solid #ddd;
  flex: 1 1 200px;
}

.previewMenuButton{
  background: linear-gradient(135deg, #f4b740, #D4AF37);
  color: #fff;
  letter-spacing: 0.7px;
  line-height: 20px;
  font-weight: bold;
}


</style>


<style scoped>

.toggelsButtons{
  background-color: #F1F5F9;
  border-radius: 20px;
  padding: 0px 10px;
}

.toggels-button {
  font-weight: 600;
  border-radius: 9999px;
  padding: 0.5rem 1.2rem;
  margin: 5px 0px;
  user-select: none;
  transition: background-color 0.3s ease;
}

.toggels-button:hover {
  background-color: #fff;
  color: black;
  cursor: pointer;
}

.toggels-button.active {
  background-color: #fff;
  color: black;
}

.empty-state {
  text-align: center;
  padding: 4rem !important;
}

.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #94a3b8;
}

.empty-content i {
  font-size: 3rem;
  opacity: 0.5;
}

</style>






